import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    TableRowDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    surface: {
        flexDirection: "row",
        alignItems: "stretch"
    },
    container: {
        alignSelf: "stretch"
    }
});

export const useStyles = ({
    isFocusVisible,
    isPressable,
    isSelected,
    measures,
    borders,
    section,
    colors,
    isLast
}: TableRowDynamicStyleType) => {
    const styles = {
        surface: {
            paddingHorizontal: Math.max(0, measures.inset - measures.cellPadding),
            borderBottomColor: colors.content.border.subtle,
            borderBottomWidth: borders.separator,
            minHeight: measures.rowHeight
        } as Mutable<ViewStyle>,
        container: {
            ...webStyle({
                cursor: isPressable ? "pointer" : "default",
                outlineStyle: "solid",
                outlineWidth: 0
            })
        } as Mutable<ViewStyle>
    };

    if(section === "body" && isLast) {
        styles.surface.borderBottomColor = "transparent";
    }

    if(section === "footer") {
        Object.assign(styles.surface, {
            borderTopColor: colors.content.border.default,
            borderTopWidth: borders.separator,
            borderBottomWidth: 0
        });
    }

    if(isSelected) {
        styles.surface.backgroundColor = colors.content.container.selected;
    }

    Object.assign(styles.surface, getFocusRingStyle({
        isFocusVisible,
        isInset: true,
        borders,
        colors
    }));

    return styles;
};
export default stylesheet;
